(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flex-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.__maisonDamasCollectionTrackingInitialized) {
    window.__maisonDamasCollectionTrackingInitialized = true;

    const assignCollectionIds = () => {
      document
        .querySelectorAll('[data-track-collection-carousel]')
        .forEach((carousel) => {
          const wrapper = carousel.querySelector('.swiper-wrapper');

          if (!wrapper) return;

          const collectionSlides = Array.from(wrapper.children).filter(
            (slide) => slide.querySelector('a[href*="/collections/"]')
          );

          collectionSlides.forEach((slide, index) => {
            const collectionLink = slide.querySelector(
              'a[href*="/collections/"]'
            );

            if (collectionLink) {
              collectionLink.id = `collection-${index + 1}`;
            }
          });
        });
    };

    assignCollectionIds();

    document.addEventListener(
      'shopify:section:load',
      assignCollectionIds
    );

    document.addEventListener('click', (event) => {
      const link = event.target.closest(
        '[data-track-collection-carousel] a[href*="/collections/"]'
      );

      if (!link) return;

      const carousel = link.closest('[data-track-collection-carousel]');
      const wrapper = link.closest('.swiper-wrapper');

      if (!carousel || !wrapper) return;

      const collectionSlides = Array.from(wrapper.children).filter(
        (slide) => slide.querySelector('a[href*="/collections/"]')
      );

      const clickedSlide = collectionSlides.find((slide) =>
        slide.contains(link)
      );

      const index = collectionSlides.indexOf(clickedSlide);

      if (index < 0) return;

      const position = index + 1;
      const collectionUrl = new URL(link.href, window.location.origin);
      const pathParts = collectionUrl.pathname.split('/').filter(Boolean);
      const collectionsIndex = pathParts.indexOf('collections');

      const collectionHandle =
        collectionsIndex >= 0
          ? pathParts[collectionsIndex + 1] || ''
          : '';

      const collectionName = (
        link.getAttribute('aria-label') ||
        link.textContent ||
        collectionHandle
      )
        .trim()
        .replace(/\s+/g, ' ');

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: `collection_click_${position}`,
        collection_position: position,
        collection_name: collectionName,
        collection_handle: collectionHandle,
        collection_url: collectionUrl.pathname,
        section_id: carousel.dataset.sectionId,
        page_path: window.location.pathname,
        source_page_type: carousel.dataset.sourcePageType,
        source_page_path: window.location.pathname,
        source_collection_handle:
          carousel.dataset.sourceCollectionHandle || '',
        source_collection_name:
          carousel.dataset.sourceCollectionName || ''
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
